import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayProfileActions, GateWayProfileActionTypes } from '../actions/gateway-profile.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayProfileEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadProfileList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayProfileActionTypes.ReadProfileList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadProfileList
      };
      const param = action.payload == null ? {otp: user.otp} : { ...action.payload, otp: user.otp };
      return this.getwayService.ReadProfileList(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertProfileList(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadProfileListFail()];
        })
      );
    })
  ));
  ReadProfileInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayProfileActionTypes.ReadProfileInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadProfileInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.ReadProfileInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertProfileInfo(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadProfileInfoFail()];
        })
      );
    })
  ));
  AddProfileInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayProfileActionTypes.AddProfileInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddProfileInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddProfileInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Profile Info Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Profile Info Fail' })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateProfileInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayProfileActionTypes.UpdateProfileInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateProfileInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpdateProfileInfo(param).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.Flag, msg: 'Update Profile Info Success' })];
          } else {
            // updateRes.msg = 'Update Profile Info Fail';
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.Message })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  DeleteProfileInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayProfileActionTypes.DeleteProfileInfo),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteProfileInfo
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.DeleteProfileInfo(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Delete Profile Info Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Profile Info Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
